// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c0d4869","899":"edc7b754"}[chunkId] + ".chunk.js";
};